/**
 * Открыть документ из закрытого бакета по временной ссылке.
 * Вкладку открываем синхронно по клику — после await браузер заблокировал бы всплывающее окно.
 */
export async function openSignedDocument(getLink: () => Promise<string>): Promise<void> {
  const win = window.open('', '_blank');
  if (win) win.opener = null;
  try {
    const url = await getLink();
    if (win) win.location.href = url;
    else window.location.assign(url);
  } catch (error) {
    win?.close();
    throw error;
  }
}
